import { HeadCell } from '@components/Table/EnhancedTableHead';
import { NomineeCustomer } from '@features/api/response/NomineeCustomer';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';

const translationBase = 'crm';

export type SortableCustomerProps = Omit<NomineeCustomer, 'categorizedData'>;

export const headerCells: readonly HeadCell<SortableCustomerProps>[] = [
  {
    id: 'id',
    numeric: true,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.id`,
    }),
  },
  {
    id: 'firstName',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.firstName`,
    }),
  },
  {
    id: 'middleName',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.middleName`,
    }),
  },
  {
    id: 'lastName',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.lastName`,
    }),
  },
];
